import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    submitLeadForm: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    submitLeadFormSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    submitLeadFormFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetLeadState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  submitLeadForm,
  submitLeadFormSuccess,
  submitLeadFormFailure,
  resetLeadState,
} = leadSlice.actions;

export default leadSlice.reducer;
